/* unplugin-vue-components disabled */import script from "./nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=8377591e&lang=css"

const __exports__ = script;

export default __exports__